"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PromoSlot } from "@/features/promo-slots/PromoSlot";
import { LivescoreStateProvider } from "@/views/livescore/state/LivescoreStateContext";
import { LivescoreClient } from "@/views/livescore/partials/LivescoreClient";
import type { NewsBlogHomeClassicData } from "../Classic/types";
import type { BrandedStyle } from "@/components/layout/SectionStrip";
import { TopLeaguesSidebar } from "./TopLeaguesSidebar";
import { PopularSportsSidebar } from "./PopularSportsSidebar";
import { LivescoreHomeNewsGrid } from "./LivescoreHomeNewsGrid";
export interface HomeNewsBlogLivescoreLayoutProps {
  data: NewsBlogHomeClassicData;
  videoShortsSlot?: React.ReactNode;
  videoHighlightsSlot?: React.ReactNode;
  sectionStyles?: Record<string, BrandedStyle>;
}
const LIVESCORE_SPORTS = ["football", "basketball", "tennis", "hockey", "american-football"] as const;
// Homepage variant intentionally omits "all" — the popular tab is the useful default.
const LIVESCORE_FILTERS = ["popular", "upcoming", "live", "finished", "my-leagues"] as const;
export function HomeNewsBlogLivescoreLayout(t0) {
  const $ = _c(34);
  const {
    data
  } = t0;
  const competitionIds = data.popularCompetitionIds;
  const locale = data.locale;
  const hero = data.promos?.[0] ?? null;
  let t1;
  if ($[0] !== hero) {
    t1 = hero && <div className="max-w-350 mx-auto px-4 pt-6"><PromoSlot row={hero} className="mb-6" /></div>;
    $[0] = hero;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== competitionIds || $[3] !== locale) {
    t2 = <div className="md:hidden max-w-350 mx-auto px-4"><TopLeaguesSidebar competitionIds={competitionIds} layout="chips" locale={locale} /></div>;
    $[2] = competitionIds;
    $[3] = locale;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== competitionIds || $[6] !== locale) {
    t3 = <TopLeaguesSidebar competitionIds={competitionIds} layout="sidebar" locale={locale} />;
    $[5] = competitionIds;
    $[6] = locale;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== locale) {
    t4 = <PopularSportsSidebar locale={locale} />;
    $[8] = locale;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="hidden md:flex md:flex-col md:w-60 md:shrink-0 gap-6">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [...LIVESCORE_SPORTS];
    t7 = [...LIVESCORE_FILTERS];
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== competitionIds || $[16] !== locale) {
    t8 = <LivescoreClient sports={t6} filters={t7} defaultSport="football" defaultFilter="popular" popularCompetitionIds={competitionIds} locale={locale} embedded={true} />;
    $[15] = competitionIds;
    $[16] = locale;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== data.featuredPosts || $[19] !== data.latestNews) {
    t9 = <LivescoreHomeNewsGrid featuredPosts={data.featuredPosts} latestPosts={data.latestNews} />;
    $[18] = data.featuredPosts;
    $[19] = data.latestNews;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <div className="flex-1 min-w-0 space-y-8">{t8}{t9}</div>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t5) {
    t11 = <div className="max-w-350 mx-auto px-4 py-4 flex gap-6">{t5}{t10}</div>;
    $[24] = t10;
    $[25] = t5;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== data.popularCompetitionsEntities || $[28] !== t11 || $[29] !== t2) {
    t12 = <LivescoreStateProvider initialFilter="popular" initialEntities={data.popularCompetitionsEntities}>{t2}{t11}</LivescoreStateProvider>;
    $[27] = data.popularCompetitionsEntities;
    $[28] = t11;
    $[29] = t2;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t1 || $[32] !== t12) {
    t13 = <div className="min-h-screen bg-background">{t1}{t12}</div>;
    $[31] = t1;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}